var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.02 307.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff !important;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,259.13v13.54q0,19.59,9.06,27.41t31.09,7.84a163,163,0,0,0,20.07-1.22,81.73,81.73,0,0,0,14.2-2.7V259.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233,104.76q0,31.32-14.92,54.83t-42.84,36.46q-27.9,13-67.07,13H74.42v27H0V150.28H103.3q25,0,39.4-11.75t14.44-33.77q0-22-13.69-33.3T103.79,60.21q-8.82,0-15.92.49T73.93,62.17V88.66H22.29A22.29,22.29,0,0,1,0,66.37V33.77q0-9.3,5.39-14.68a35.6,35.6,0,0,1,14.2-8.32Q35.73,4.89,58.26,2.45A377.34,377.34,0,0,1,98.89,0Q165,0,199,28.14T233,104.76Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/LogoDark.dd2503f2418a772e4e2a61303f6573e4.svg";
export { ForwardRef as ReactComponent };